import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { HIGHLIGHT_COLOR } = constants;

let styles = {
  base: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start'
  },
  menu: {
    position: 'relative',
    display: 'inline-block'
  },
  icon: {
    flexShrink: 0,
    cursor: 'pointer',
    height: 4,
    width: 20
  },
  ul: {
    visibility: 'hidden',
    opacity: 0,
    listStyle: 'none',
    position: 'absolute',
    top: 18,
    left: 6,
    backgroundColor: 'white',
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
    borderRadius: 8,
    zIndex: 1,
    width: 100,
    marginTop: 8,
    marginLeft: -45,
    padding: '10px 0',
    transition:
      'all 0.2s ease-in-out 0s, visibility 0s ' +
      'linear 0.2s, z-index 0s linear 0.01s',
    ':before': {
      content: `''`,
      width: 0,
      height: 0,
      position: 'absolute',
      borderLeft: '7px solid transparent',
      borderRight: '7px solid transparent',
      borderBottom: '7px solid white',
      left: 'calc(50% - 6px)',
      top: -7
    }
  },
  ulshow: {
    visibility: 'visible',
    opacity: 1,
    zIndex: 1,
    transform: 'translateY(0%)',
    transitionDelay: '0s, 0s, 0.2s'
  },
  items: {
    maxHeight: 168,
    overflowY: 'auto'
  },
  li: {
    fontSize: '1em',
    padding: 12,
    fontWeight: 500,
    color: 'black',
    textDecoration: 'none',
    ':hover': {
      backgroundColor: HIGHLIGHT_COLOR,
      color: 'white'
    }
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/accordionmenu/AccordionMenu.styles.js